import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'removeHtml'
})
export class removeHtmlPipe implements PipeTransform {
  transform(value: string): string {
    return value ? value.replace(/<[^>]+>/g, '') : '';
  }
}
